import { useEffect, useState } from 'react';
import { YField, YSelect } from '../../../../components/yool/YoolPrimitives';
import { getProductos } from '../../../../services/divinaProductsService';
import { getProductoIdsConPlanColectivo } from '../../../../services/divinaPlanesService';

export default function PasoProducto({ companiaId, value, onChange }) {
  const [productos, setProductos] = useState([]);
  const [productoIdsColectiva, setProductoIdsColectiva] = useState(new Set());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let ignore = false;
    Promise.all([getProductos(), getProductoIdsConPlanColectivo()])
      .then(([productosData, idsColectiva]) => {
        if (ignore) return;
        setProductos(productosData);
        setProductoIdsColectiva(idsColectiva);
      })
      .catch((error) => console.warn('Error al obtener productos:', error))
      .finally(() => { if (!ignore) setLoading(false); });
    return () => { ignore = true; };
  }, []);

  if (!companiaId) {
    return <p className="y-field-hint">Selecciona una compañía primero.</p>;
  }

  // Solo productos con al menos un plan colectiva activo — un producto
  // sin eso no puede tener una póliza colectiva (regla real, ver PasoPlan).
  const disponibles = productos.filter(
    (p) => String(p.compania_id) === String(companiaId) && productoIdsColectiva.has(p.id)
  );

  return (
    <YField
      label="Producto"
      required
      hint={disponibles.length === 0 ? 'Esta compañía no tiene productos con un plan colectiva — habilítalo desde Product Config → Productos y vuelve a este paso.' : undefined}
    >
      <YSelect
        data-testid="select-producto"
        value={value?.producto_id || ''}
        onChange={(e) => onChange({ producto_id: e.target.value })}
        disabled={loading}
      >
        <option value="">{loading ? 'Cargando...' : 'Selecciona producto'}</option>
        {disponibles.map((p) => (
          <option key={p.id} value={p.id}>{p.nombre}</option>
        ))}
      </YSelect>
    </YField>
  );
}
